import update from "immutability-helper";
import { REQUEST_SCHEDULED_BOOKINGS, SET_SCHEDULED_BOOKINGS } from './scheduled-bookings-actions';

const initialState = {
  isFetching: false,
  journeyReports: []
};

function scheduledBookingsReducer(state = initialState, action) {
  switch (action.type) {
    case REQUEST_SCHEDULED_BOOKINGS:
      return update(state, {
        isFetching: {$set: true}
      });
    case SET_SCHEDULED_BOOKINGS:
      return update(state, {
        journeyReports: {$set: action.payload}
      });
    default:
      return state;
  }
}

export default scheduledBookingsReducer;



// WEBPACK FOOTER //
// ./src/components/scheduled-bookings/scheduled-bookings-reducer.js